import { useState, useEffect } from 'react';
import { DownloadFileFunctionType } from '../../../../../../shared/hooks/use-file-upload.hook';
import { FileBasicData } from '../../../../../../shared/model/nx-file.model';

export function useFileLoadingTracker() {
  const [fileLoadingStatus, setFileLoadingStatus] = useState<{[key: string]: boolean}>({});
  const [areAllFilesLoaded, setAreAllFilesLoaded] = useState(true);
  
  const trackFileDownload = async (
    fileBasicData: FileBasicData, 
    checkId: number, 
    downloadFile: DownloadFileFunctionType
  ) => {
    try {
      setFileLoadingStatus(prev => ({...prev, [checkId]: false}));
      await downloadFile(fileBasicData);
      setFileLoadingStatus(prev => ({...prev, [checkId]: true}));
    } catch (error) {
      console.error('Error downloading file:', error);
      setFileLoadingStatus(prev => ({...prev, [checkId]: true})); // Mark as loaded even on error
    }
  };
  
  useEffect(() => {
    // Check if all files are loaded
    if (Object.keys(fileLoadingStatus).length > 0) {
      const allLoaded = Object.values(fileLoadingStatus).every(status => status);
      setAreAllFilesLoaded(allLoaded);
    } else {
      setAreAllFilesLoaded(true);
    }
  }, [fileLoadingStatus]);
  
  return {
    fileLoadingStatus,
    areAllFilesLoaded,
    trackFileDownload,
    setFileLoadingStatus
  };
}